import { Box, type BoxProps, styled } from '@mui/material';

export const UploadFieldWrap = styled(Box)<{ mini?: boolean }>(({ theme, mini }) => [
    {
        display: 'grid',
        gridTemplateColumns: mini ? '1fr' : '1fr minmax(120px, min-content)',
        gap: '20px',
        padding: mini ? 0 : '4px 4px 4px 8px',
        borderRadius: mini ? 0 : '12px',
        background: mini ? 'none' : theme.palette.secondary.light,
    },
    mini && {
        justifyItems: 'flex-start',
    },
]);

export const UploadFieldText = styled(Box)<BoxProps<'label'>>(({ theme }) => ({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '.MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: theme.custom.c22,
    },
}));
